import { render, staticRenderFns } from "./BaseBtnScroll.vue?vue&type=template&id=102ab439&lang=pug"
import script from "./BaseBtnScroll.vue?vue&type=script&lang=js"
export * from "./BaseBtnScroll.vue?vue&type=script&lang=js"
import style0 from "./BaseBtnScroll.vue?vue&type=style&index=0&id=102ab439&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports